import { MovableImageItem } from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from ".";
import { PaintStyle } from "../../../../domain/drawing";
import {
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IEnableConfiguration,
  IMovableImageObjectStyleConfiguration,
} from "../../../../domain/configuration";

export class MovableImageObjectStyleReader extends AbstractObjectStyleReader<MovableImageItem> {
  constructor(private readonly _configuration: IMovableImageObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: MovableImageItem): PaintStyle {
    return null;
  }

  protected readBackgroundColorConfiguration(source: MovableImageItem): IBackgroundColorConfiguration {
    return null;
  }

  protected readBorderColorConfiguration(source: MovableImageItem): IBorderColorConfiguration {
    return null;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
